import clsx from 'clsx';
import { SettingItemActions } from '../../../SettingItemActions';
import React, { ChangeEvent, useState } from 'react';
import { useForm } from '../../../../../../hooks/useForm';
import { Input } from '../../../../../../components/Input';
import { Label } from '../../../../../../components/Label';
import { SettingTag } from '../../../SettingTag';

interface Props {
  index: number;
  cloudDvr: CreateCloudDvr;
  onRemove?(index: number): void;
  onSave?(item: CreateCloudDvr, index: number): void;
}

interface Content extends Props {
  editing: boolean;
}

interface Form extends Content {
  values: CreateCloudDvr;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
  updateField(field: keyof CreateCloudDvr, value: any): void;
}

export const CloudDvr = (props: Props) => {
  const [editing, setEditing] = useState(false);
  const { index, onRemove = null, onSave = null, cloudDvr } = props;
  const { values, onChange, updateField } = useForm<CreateCloudDvr>(
    cloudDvr,
    () => null
  );

  return (
    <div
      className={clsx(
        'w-full inline-flex items-center justify-between gap-4 h-14'
      )}
    >
      <EditCloudDvr
        editing={editing}
        onChange={onChange}
        updateField={updateField}
        values={values}
        {...props}
      />
      <CloudDvrContent editing={editing} {...props} />
      {onRemove && onSave ? (
        <SettingItemActions
          canSave={
            (values.description ?? '').trim() !== '' &&
            (values.mediafirstId ?? '').trim() !== '' &&
            (values.featureSubscriptionId ?? '').trim() !== ''
          }
          editing={editing}
          onEdit={() => setEditing(true)}
          onRemove={() => onRemove(index)}
          onSave={() => {
            onSave(values, index);
            setEditing(false);
          }}
          onCancel={() => setEditing(false)}
        />
      ) : null}
    </div>
  );
};

const EditCloudDvr = ({ editing, values, onChange }: Form) => {
  const defaultProps: any = {
    variant: 'contained',
    onChange: onChange,
    required: true,
  };

  if (editing === false) return null;
  return (
    <fieldset className="inline-flex items-center gap-4">
      <Input
        name="description"
        label="Description"
        value={values.description}
        {...defaultProps}
      />
      <Input
        name="mediafirstId"
        label="MediaFirst ID"
        value={values.mediafirstId}
        {...defaultProps}
      />
      <Input
        name="featureSubscriptionId"
        label="Subscription ID"
        value={values.featureSubscriptionId}
        {...defaultProps}
      />
    </fieldset>
  );
};

const CloudDvrContent = ({ editing, cloudDvr }: Content) => {
  if (editing) return null;

  return (
    <>
      <SettingTag name={cloudDvr.description} color="teal" />
      <Label text="MediaFirst ID:" align="left">
        {cloudDvr.mediafirstId}
      </Label>
      <Label text="Subscription ID:" align="left">
        {cloudDvr.featureSubscriptionId}
      </Label>
    </>
  );
};
